import { render, staticRenderFns } from "./RecoveryTerms.vue?vue&type=template&id=6fee2082&scoped=true&"
import script from "./RecoveryTerms.vue?vue&type=script&lang=ts&"
export * from "./RecoveryTerms.vue?vue&type=script&lang=ts&"
import style0 from "./RecoveryTerms.vue?vue&type=style&index=0&id=6fee2082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee2082",
  null
  
)

export default component.exports